import React from 'react';
import { Footer } from 'ui-toolkit';
import { SubmitButton } from './SubmitButton';
import { Copyright } from '../../ui-toolkit/components/Copyright/Copyright';

export const FormFooter: React.FC = () => {
  return (
    <>
      <Footer>
        <SubmitButton data-test-id={'bottom-submit'} />
      </Footer>
      <Copyright />
    </>
  );
};
